import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';

import TopBar from './TopBar';
import LocationButton from './LocationButton';

function RefundModel() {
  const { t } = useLanguage();

  return (
    <TopLevelWrapper>
      <TopBar />
      <BottomWrapper>
        <LocationButton nowPage={'Refund'} />
        <TextWrapper>
          <BlackTitle style={{ marginTop: `38px` }}>{t('rules.refund.b1')}</BlackTitle>

          <BlackTitle style={{ marginTop: `14px` }}>{t('rules.refund.b2')}</BlackTitle>
          <Text>{t('rules.refund.p1')}</Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.refund.t1')}</Title>

          <BlackTitle style={{ marginTop: `14px` }}>{t('rules.refund.b3')}</BlackTitle>

          <BlackTitle style={{ marginTop: `14px` }}>{t('rules.refund.b4')}</BlackTitle>
          <Text>{t('rules.refund.p2')}</Text>

          <BlackTitle style={{ marginTop: `14px` }}>{t('rules.refund.b5')}</BlackTitle>
          <Text>{t('rules.refund.p3')}</Text>

          <BlackTitle style={{ marginTop: `14px` }}>{t('rules.refund.b6')}</BlackTitle>
          <Text>{t('rules.refund.p4')}</Text>

          <BlackTitle style={{ marginTop: `14px` }}>{t('rules.refund.b7')}</BlackTitle>
          <Text>{t('rules.refund.p5')}</Text>

          <BlackTitle style={{ marginTop: `14px` }}>{t('rules.refund.b8')}</BlackTitle>
          <Text>{t('rules.refund.p6')}</Text>

          <BlackTitle style={{ marginTop: `14px` }}>{t('rules.refund.b9')}</BlackTitle>
          <Text>{t('rules.refund.p7')}</Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.refund.t2')}</Title>
          <Table>
            <Tr>
              <Td style={{ backgroundColor: `#FF8B48` }}>
                <Text style={{ color: `#FFFFFF` }}>{t('rules.refund.table2_header1')}</Text>
              </Td>
              <Td style={{ backgroundColor: `#FF8B48` }}>
                <Text style={{ color: `#FFFFFF` }}>{t('rules.refund.table2_header2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r1c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r1c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r2c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r2c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r3c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r3c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r4c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r4c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r5c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r5c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r6c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r6c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r7c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r7c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r8c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r8c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r9c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r9c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table2_r10c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table2_r10c2')}</Text>
              </Td>
            </Tr>
          </Table>
          <Text style={{marginTop: `16px`}}>{t('rules.refund.p8')}</Text>
          <Text>{t('rules.refund.p9')}</Text>
          <Text>{t('rules.refund.p10')}</Text>
          <Text>{t('rules.refund.p11')}</Text>
          <Text>{t('rules.refund.p12')}</Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.refund.t3')}</Title>
          <Table>
            <Tr>
              <Td style={{ backgroundColor: `#FF8B48` }}>
                <Text style={{ color: `#FFFFFF` }}>{t('rules.refund.table3_header1')}</Text>
              </Td>
              <Td style={{ backgroundColor: `#FF8B48` }}>
                <Text style={{ color: `#FFFFFF` }}>{t('rules.refund.table3_header2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table3_r1c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table3_r1c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table3_r2c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table3_r2c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table3_r3c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table3_r3c2')}</Text>
              </Td>
            </Tr>
          </Table>

          <Text style={{marginTop: `16px`}}>{t('rules.refund.p13')}</Text>
          <Text>{t('rules.refund.p14')}</Text>
          <BlackTitle>{t('rules.refund.b10')}</BlackTitle>
          <Text style={{ marginLeft: `12px`}}>{t('rules.refund.p15')}</Text>
          <Text style={{ marginLeft: `12px`}}>{t('rules.refund.p16')}</Text>
          <Text style={{ marginLeft: `12px`}}>{t('rules.refund.p17')}</Text>
          <Text style={{ marginLeft: `12px`}}>{t('rules.refund.p18')}</Text>
          <Text style={{ marginLeft: `12px`}}>{t('rules.refund.p19')}</Text>
          <Text style={{ marginLeft: `12px`}}>{t('rules.refund.p20')}</Text>
          <Text style={{ marginLeft: `12px`}}>{t('rules.refund.p21')}</Text>


          <Title style={{ marginTop: `38px` }}>{t('rules.refund.t4')}</Title>

          <Table>
            <Tr>
              <Td style={{ backgroundColor: `#FF8B48` }}>
                <Text style={{ color: `#FFFFFF` }}>{t('rules.refund.table4_header1')}</Text>
              </Td>
              <Td style={{ backgroundColor: `#FF8B48` }}>
                <Text style={{ color: `#FFFFFF` }}>{t('rules.refund.table4_header2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td style={{height: `76px`}}>
                <Text>{t('rules.refund.table4_r1c1_1')}</Text>
                <Text>{t('rules.refund.table4_r1c1_2')}</Text>
              </Td>
              <Td style={{height: `76px`}}>
                <Text>{t('rules.refund.table4_r1c2')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td style={{height: `136px`}}>
                <Text>{t('rules.refund.table4_r2c1_1')}</Text>
                <Text>{t('rules.refund.table4_r2c1_2')}</Text>
                <Text>{t('rules.refund.table4_r2c1_3')}</Text>
                <Text>{t('rules.refund.table4_r2c1_4')}</Text>
              </Td>
              <Td style={{height: `136px`}}>
                <Text>{t('rules.refund.table4_r2c2_1')}</Text>
                <Text>{t('rules.refund.table4_r2c2_2')}</Text>
                <Text>{t('rules.refund.table4_r2c2_3')}</Text>
                <Text>{t('rules.refund.table4_r2c2_4')}</Text>
                <Text>{t('rules.refund.table4_r2c2_5')}</Text>
              </Td>
            </Tr>
            <Tr>
              <Td>
                <Text>{t('rules.refund.table4_r3c1')}</Text>
              </Td>
              <Td>
                <Text>{t('rules.refund.table4_r3c2')}</Text>
              </Td>
            </Tr>
          </Table>

          <Text style={{marginTop: `16px`}}>{t('rules.refund.p22')}</Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.refund.t5')}</Title>

          <Text style={{marginTop: `16px`}}>{t('rules.refund.p23')}</Text>
          <Text>{t('rules.refund.p24')}</Text>
          <Text>{t('rules.refund.p25')}</Text>
          <Text>{t('rules.refund.p26')}</Text>

          <Title style={{ marginTop: `38px` }}>{t('rules.refund.t6')}</Title>

          <Text style={{marginTop: `16px`}}>{t('rules.refund.p27')}</Text>
          <Text style={{marginBottom: `96px`}}>{t('rules.refund.p28')}</Text>
        </TextWrapper>
      </BottomWrapper>
    </TopLevelWrapper>
  )
}

export default RefundModel;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  background-color: ${props => props.theme.background};
`;

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 1194px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const BlackTitle = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.primary};

  margin: 0 0 0 0;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const Table = styled.table`
  display: flex;
  flex-direction: column;

  justify-content: center;
  aling-items: center;

  margin-top: 16px;
`;

const Tr = styled.tr`
  display: flex;
  flex-directi: row;

  justify-content: center;
  aling-items: center;
`;

const Td = styled.td`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 597px;
  height: 56px;

  border: 1px solid ${props => props.theme.line}
`;
